module.exports = __webpack_public_path__ + "static/img/icon-c-location.07dfff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-location.png
// module id = U5L+
// module chunks = 21